<template>
  <div class="modal-overlay" v-if="isVisible" @click.self="close">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ $t('limitsModal.title') }}</h4>
          <button type="button" class="btn-close" @click="close" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p id="limits-message">{{ message || $t('limitsModal.default_message') }}</p>
          <p>{{ $t('limitsModal.upgrade_hint') }}</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="goToPrice">{{ $t('limitsModal.upgrade') }}</button>
          <button type="button" class="btn btn-outline-primary" @click="close">{{ $t('limitsModal.cancel') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  message: { type: String, default: '' }
})
const emit = defineEmits(['close'])

const isVisible = ref(true)
const localePath = useLocalePath()

const close = () => {
  isVisible.value = false
  emit('close')
}

const goToPrice = () => {
  close()
  navigateTo(localePath('/price'))
}
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.modal-dialog {
  width: 100%;
  max-width: 500px;
  margin: auto;
}

.modal-content {
  background: #fff;
  border-radius: $r-lg;
  overflow: hidden;
  box-shadow: $shadow-warm-lg;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid $line;

  .modal-title {
    margin: 0;
    font-size: 1rem;
    font-weight: 700;
    color: $berry;
  }

  .btn-close {
    background: transparent;
    border: none;
    font-size: 1.2rem;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity 0.2s;
    &:hover { opacity: 1; }
  }
}

.modal-body {
  padding: 20px;
  font-size: 0.88rem;
  line-height: 1.8;
  color: $ink;

  p {
    margin: 0 0 12px;

    strong { color: $ink; }
  }
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 20px;
  border-top: 1px solid $line;

  .btn {
    padding: 8px 18px;
    border-radius: $r-pill;
    font-size: 0.84rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.25s;
    border: 1.5px solid;

    &.btn-primary {
      background: $leaf;
      border-color: $leaf;
      color: #fff;

      &:hover { background: $leaf-deep; border-color: $leaf-deep; }
      &:active { transform: scale(0.97); }
    }

    &.btn-outline-primary {
      background: transparent;
      border-color: $leaf;
      color: $leaf;

      &:hover { background: $leaf; color: #fff; }
      &:active { transform: scale(0.97); }
    }
  }
}
</style>
